import { motion, useReducedMotion } from "framer-motion";
import { LANDING_COPY, STEPS } from "@/data/landingContent";
import { StepDebriefArt, StepEnterArt, StepTalkArt } from "./illustrations/SceneArt";

const STEP_ART = [StepEnterArt, StepTalkArt, StepDebriefArt];

export const HowItWorks = () => {
  const reduce = useReducedMotion();

  return (
    <section id="como" className="container mx-auto scroll-mt-24 px-5 py-20 md:px-8">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.5 }}
      >
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500">
          {LANDING_COPY.howEyebrow}
        </p>
        <h2 className="mt-3 max-w-3xl text-3xl font-bold tracking-[-0.03em] md:text-4xl">
          {LANDING_COPY.howTitle}
        </h2>
        <p className="mt-3 max-w-2xl text-base text-neutral-500 md:text-lg">{LANDING_COPY.howSub}</p>
      </motion.div>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {STEPS.map((step, index) => {
          const Art = STEP_ART[index];
          return (
            <motion.article
              key={step.title}
              className="landing-card overflow-hidden rounded-[22px] border border-neutral-200 bg-white"
              initial={reduce ? false : { opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: reduce ? 0 : index * 0.08 }}
            >
              <Art className="h-36 w-full" />
              <div className="px-5 py-5">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-neutral-200 text-sm font-semibold text-neutral-900">
                  {index + 1}
                </span>
                <h3 className="mt-4 text-lg font-semibold text-neutral-900">{step.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-neutral-500">{step.body}</p>
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
};
